import React from "react";
import CustomTooltip from "../../../../components/CustomTooltip";
import EventMetaItemApp from "../Functionality/EventMetaItemApp";

/**
 * @Author      Karen Yunuen Pozos Arias
 * @JobTitle    Full Stack
 * @Email       kpozos@ibl.mx
 *
 * Icon and value of an event, optionally preceded by its label.
 *
 * @param {React.ElementType} Icon - Icon of the information.
 * @param {string} label - Translation key of the label.
 * @param {string} value - Value to display.
 * @param {boolean} showLabel - Shows "Label: value".
 */
const EventMetaItem = ({ Icon, label, value, showLabel = false }) => {
    const { text } = EventMetaItemApp({ label, value, showLabel });

    return (
        <div className='d-flex align-items-center gap-2 minw-0'>
            {Icon && <Icon className='btn-icon-svg-16px flex-shrink-0 icon-color-shades-500' />}
            <CustomTooltip
                text={text}
                classes='fs-14px ibl-font-w-400 font-color-shades-500 text-ellipsis-1-row'
                showIfTruncated
                placement='top'
            />
        </div>
    );
};

export default EventMetaItem;
